export * from "./ugc.component"
export * from "./products.component"
export * from "./share-menu.component"
export * from "./static.component"
export * from "./tile-component"
export * from "./add-to-cart.component"
